module.exports = __webpack_public_path__ + "static/media/iconMetricO3.452f14b6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/Icons/iconMetricO3.svg
// module id = 1134
// module chunks = 0